export class JSONUtilites {

  static arrayFromJSON<T>(type: (new () => T), json: string, createFromAnyMethod?: any): T[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: T[] = [];
    for (const item of values) {
      result.push(JSONUtilites.createTemplateObject(type, item, createFromAnyMethod));
    }

    return result;
  }

  static fromJSON<T>(type: (new () => T), json: string, createFromAnyMethod?: any): T {
    const values = JSON.parse(json);
    if (!values) {
      return null;
    }

    return JSONUtilites.createTemplateObject(type, values, createFromAnyMethod);
  }

  private static createTemplateObject<T>(type: (new () => T), params: any = {}, createFromAnyMethod?: any): T {
    return createFromAnyMethod ? createFromAnyMethod(params) : Object.assign(new type(), params);
  }
}
